import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React, { useMemo } from 'react';
import useLocalFile from './useLocalFile';
import FileFormField from '../File';
import getHumanFileSize from '../../../utils/formatting/getHumanFileSize';
import { Grid, FormLabel } from '@material-ui/core';
var baseStyle = {
  display: 'inline-block',
  border: '1px solid transparent'
};
var activeStyle = {
  borderColor: 'orange'
};
var acceptStyle = {
  borderColor: 'green'
};
var rejectStyle = {
  borderColor: 'red'
};

var extractFileName = function extractFileName(value, multi) {
  if (!value) return '';
  if (multi) return value.length == 1 ? value[0].name : value.map(function (f) {
    return "\"".concat(f.name, "\" ");
  });else return value.name;
};
/**
 * @param {import('../types').FormInputLocalFileProps} props
 */


function LocalFileFormInput(props) {
  var disableDrop = props.disableDrop,
      disableClick = props.disableClick,
      multi = props.multi,
      value = props.value,
      onChange = props.onChange,
      style = props.style,
      preview = props.preview,
      children = props.children,
      fullWidth = props.fullWidth,
      onAdd = props.onAdd,
      placeholder = props.placeholder,
      name = props.name,
      variant = props.variant,
      classes = props.classes,
      maxSize = props.maxSize,
      rest = _objectWithoutProperties(props, ["disableDrop", "disableClick", "multi", "value", "onChange", "style", "preview", "children", "fullWidth", "onAdd", "placeholder", "name", "variant", "classes", "maxSize"]);

  var _useLocalFile = useLocalFile(props),
      acceptedFiles = _useLocalFile.acceptedFiles,
      rejectedFiles = _useLocalFile.rejectedFiles,
      getRootProps = _useLocalFile.getRootProps,
      getInputProps = _useLocalFile.getInputProps,
      isDragActive = _useLocalFile.isDragActive,
      isDragAccept = _useLocalFile.isDragAccept,
      isDragReject = _useLocalFile.isDragReject;

  var dropAreaStyle = useMemo(function () {
    return _objectSpread({}, baseStyle, style, isDragActive ? activeStyle : {}, isDragAccept ? acceptStyle : {}, isDragReject ? rejectStyle : {}, {
      width: fullWidth ? '100%' : 'auto'
    });
  }, [isDragActive, isDragReject]);
  /**@type {React.ReactNode} */

  var content = preview ? React.createElement("div", null, "CHOOSE FILE") : React.createElement(FileFormField, {
    value: extractFileName(value, multi),
    placeholder: placeholder,
    name: name,
    label: null,
    variant: variant,
    disabled: disableClick && disableDrop
  });
  if (typeof children === 'function') content = children(multi ? acceptedFiles : acceptedFiles[0]);else if (children) content = children;
  return React.createElement("div", getRootProps({
    style: dropAreaStyle
  }), React.createElement("input", getInputProps(rest)), content, maxSize && rejectedFiles && rejectedFiles.length > 0 ? React.createElement(FormLabel, {
    error: true,
    style: {
      textAlign: "center"
    }
  }, React.createElement(Grid, {
    item: true,
    alignItems: "center",
    justify: "center"
  }, "Cannot select file. Make sure file size is under ".concat(getHumanFileSize(maxSize), " and file is an image type."))) : '');
}

LocalFileFormInput.defaultProps = {
  disableDrop: false,
  disableClick: false,
  multi: false,
  preview: false,
  accept: null,
  fullWidth: false,
  placeholder: 'No file selected',
  variant: 'standard'
};
export default LocalFileFormInput;